import * as React from 'react';
import ReactDOM from 'react-dom';
import renderHTML  from 'react-render-html';

import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { DetailsList,  DetailsListLayoutMode,  SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Label } from 'office-ui-fabric-react/lib/Label';

import { BloccoGdpr } from './BloccoGdpr.js';
import { BloccoGdprInfo } from './BloccoGdprInfo.js';
import { BloccoGdprEInfo } from './BloccoGdprEInfo.js';

import { DeleteAccount } from './DeleteAccount.js';

import { Config } from './Config.js';
import { Azioni } from './classi/Azioni.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';


import './css/Site.css';
import './css/Home.css';
import './css/DialogBox.css';

/* NON TOCCARE, spariscono le icone */
initializeIcons();

const sessione = new Session();
const config = new Config();
const azioni = new Azioni();
const utils = new Utils();

export class Home extends React.Component {
    
    constructor(){
        super();
        this.state = {
            anagrafica: [],
            anagraficagas: [],

            utente : [],
            commerciale : [],
            errorMessage: '',
            id_cliente: false,
            
            vedi_commeciale : false,
            errore_commerciale : false,
            
            edit_anagrafica : false,
            edit_sedelegale : false,
            edit_privacy : true,
            
            mostraEliminaAccount : 'nascosto',
            mostraCancellaPassword : 'nascosto',
            
            vediwarningpagamenti:'nascosto',
            warningpagamentitxt:'',
            
            visualizzaEE : '',
            visualizzaGAS : '',
            
            vedi_privacy : false,
            vedi_terze_parti : false,
            gdpr_contratto : '',
            gdpr_commerciale : '',
            gdpr_profilazione : '',
            gdpr_infoprivacy : '',
            gdpr_terzeparti : '',
            
            gdpr_contratto_desc : '',
            gdpr_commerciale_desc : '',
            gdpr_profilazione_desc : '',
            gdpr_infoprivacy_desc : '',
            gdpr_terzeparti_desc : '',
            
            campo_vuoto : 'non settato'
        };
        
        this.impostaParametriHome = this.impostaParametriHome.bind(this);
        
        this.controllaBlocchiPopupGDPR = this.controllaBlocchiPopupGDPR.bind(this);
        
        this.chiamaDeleteAccount = this.chiamaDeleteAccount.bind(this);
        
        utils.pulisciBoxInfoCliente();
    }
    
    
    impostaParametriHome()
    { 
        // visualizzazione BOX COMMERCIALE
        if( true !== utils.getInfoSocieta( 'HOME_AGENTE' , false ) ){ this.setState({vedi_commerciale:false}); }else{ this.setState({vedi_commerciale:true});}
        
        // visualizzazione EDIT ANAGRAFICA
        // gestione da MS381_AC2_CUSTOMIZATION
        if( true !== utils.getInfoSocieta( 'VISUALIZZA_MOD_ANAG' , true ) ){ this.setState({edit_anagrafica:false}); }else{ this.setState({edit_anagrafica:true});}
        
        // visualizzazione EDIT SEDE LEGALE
        // gestione da MS381_AC2_CUSTOMIZATION
        if( true !== utils.getInfoSocieta( 'VISUALIZZA_MOD_SEDE_LEG' , true ) ){ this.setState({edit_sedelegale:false}); }else{ this.setState({edit_sedelegale:true});}
        
        // VISUALIZZA_FLG_GDPR
        if( true !== utils.getInfoSocieta( 'VISUALIZZA_FLG_GDPR' , true ) ){ this.setState({vedi_privacy:false}); }else{ this.setState({vedi_privacy:true});}
        
        
        // VISUALIZZA_TERZE_PARTI_GDPR
        if( true !== utils.getInfoSocieta( 'VISUALIZZA_TERZE_PARTI_GDPR' , false ) ){ this.setState({vedi_terze_parti:false}); }else{ this.setState({vedi_terze_parti:true});}
        
        
        let ID_AGGREGATO = sessione.get('id_aggregato');
        let ID_AMMINISTRATORE = sessione.get('id_amministratore');
        
        if( ( ID_AMMINISTRATORE !== '' && ID_AMMINISTRATORE !== 0 && ID_AMMINISTRATORE !== null ) || ( ID_AGGREGATO !== '' && ID_AGGREGATO !== 0 && ID_AGGREGATO !== null ) ){
            // se AGGREGATO o AMMINISTRATORE ... non mostrare il bottone Elimina Account
        } else {
            if( utils.getObjInfoSocieta( 'ABILITA_DELETE_ACCOUNT' , 'NO' ) === 'NO' ){ this.setState({mostraEliminaAccount:'nascosto', mostraCancellaPassword:'nascosto'}); }
            else if( utils.getObjInfoSocieta( 'ABILITA_DELETE_ACCOUNT' , 'NO' ) === 'SI' ){ this.setState({mostraEliminaAccount:'', mostraCancellaPassword:'nascosto'}); } // questo lo usa sinergy
            else{ this.setState({mostraEliminaAccount:'nascosto', mostraCancellaPassword:''}); }
        }

        this.setState({
            gdpr_contratto_desc:utils.getObjInfoSocieta( 'GDPR_CONTRATTO_DESC' , '' ),
            gdpr_commerciale_desc:utils.getObjInfoSocieta( 'GDPR_COMMERCIALE_DESC' , '' ),
            gdpr_profilazione_desc:utils.getObjInfoSocieta( 'GDPR_POFILAZIONE_DESC' , '' ),
            gdpr_infoprivacy_desc:utils.getObjInfoSocieta( 'GDPR_INFOPRIVACY_DESC' , '' ),
            gdpr_terzeparti_desc:utils.getObjInfoSocieta( 'GDPR_TERZE_PARTI_DESC' , '' )
        });
    }

    
    /* spostato 2019-10-02 */
    controllaBlocchiPopupGDPR(result){
        let GDPRTipoPopup = utils.getObjInfoSocieta( 'AUTH_POPUP_TYPE' , '' );

        let GDPRobbligo = utils.getObjInfoSocieta( 'GDPR_OBBLIGO_COMPILA' , '' );
        let GDPRvedi = utils.getObjInfoSocieta( 'VISUALIZZA_FLG_GDPR' , '' );
        let GDPRaccept = utils.getObjInfoSocieta( 'GDPR_VALORI_ACCETTATI' , '' );
        
        let GDPRvedi_terze_parti = utils.getObjInfoSocieta( 'VISUALIZZA_TERZE_PARTI_GDPR' , '' );

        let GDPRcont = result.data.utente.FLG_GDPR_CONTRATTO;
        let GDPRcomm = result.data.utente.FLG_GDPR_COMMERCIALE;
        let GDPRprof = result.data.utente.FLG_GDPR_POFILAZIONE;
        let GDPRinfo= result.data.utente.FLG_GDPR_INFOPRIVACY;
        let GDPRterze= result.data.utente.FLG_GDPR_TERZE_PARTI;

        let autologin = utils.getObjInfoSocieta( 'autologin' , false );

        let ID_AGGREGATO = sessione.get('id_aggregato');
        let ID_AMMINISTRATORE = sessione.get('id_amministratore');


        let CONTROLLA_GDPR = true;

        // Controlli GDPR se non sono Amministratore o Aggregato
        if( ( ID_AMMINISTRATORE !== '' && ID_AMMINISTRATORE !== 0 && ID_AMMINISTRATORE !== null ) || ( ID_AGGREGATO !== '' && ID_AGGREGATO !== 0 && ID_AGGREGATO !== null ) ){
            CONTROLLA_GDPR = false;
        }
        
        
        if( CONTROLLA_GDPR === true){
            
            if(GDPRTipoPopup === '1_popup_solo_gdpr'){
                // se c'è uno dei 3 flag non impostati... obbligo a impostarli
                if(  autologin===false && GDPRobbligo==='SI' && GDPRvedi==='SI' && 
                        ( GDPRcont==='' || GDPRcont===null || GDPRcomm==='' || GDPRcomm===null || GDPRprof==='' || GDPRprof===null 
                        || (GDPRterze==='' && GDPRvedi_terze_parti==='SI') || (GDPRterze===null && GDPRvedi_terze_parti==='SI') ) )
                {
                    ReactDOM.render(<BloccoGdpr />, document.getElementById('root')); 
                }
            }
            else if(GDPRTipoPopup === '1_popup_info_e_gdpr_assieme'){

                // se c'è uno dei 4 flag non impostati... obbligo a impostarli
                if(  autologin===false && GDPRobbligo==='SI' && GDPRvedi==='SI' && 
                        ( GDPRcont==='' || GDPRcont===null || GDPRcomm==='' || GDPRcomm===null || GDPRprof==='' || GDPRprof===null || GDPRinfo==='' || GDPRinfo===null 
                        || (GDPRterze==='' && GDPRvedi_terze_parti==='SI') || (GDPRterze===null && GDPRvedi_terze_parti==='SI')  ) )
                {
                    ReactDOM.render(<BloccoGdprEInfo />, document.getElementById('root'));
                }
            }
            else if(GDPRTipoPopup === '2_popup_info_poi_gdpr'){

                // primo STEP : obbligatorio Flaggare INFOPRIVACY
                if(  autologin===false && GDPRobbligo==='SI' && GDPRvedi==='SI' && ( GDPRinfo==='' || GDPRinfo===null || 
                        ( parseInt(GDPRinfo,10)===0 && ( typeof GDPRaccept[3] !== 'undefined' ) && GDPRaccept[3].indexOf('NO')===-1 ) ||
                        ( parseInt(GDPRinfo,10)===1 && ( typeof GDPRaccept[3] !== 'undefined' ) && GDPRaccept[3].indexOf('SI')===-1 )
                    ) 
                ){
                    ReactDOM.render(<BloccoGdprInfo />, document.getElementById('root')); 
                }

                // secondo STEP : compilazione FLAG GDPR
                else if(  autologin===false && GDPRobbligo==='SI' && GDPRvedi==='SI' && 
                        ( GDPRcont==='' || GDPRcont===null || GDPRcomm==='' || GDPRcomm===null || GDPRprof==='' || GDPRprof===null 
                         || (GDPRterze==='' && GDPRvedi_terze_parti==='SI') || (GDPRterze===null && GDPRvedi_terze_parti==='SI') ) )
                {
                    ReactDOM.render(<BloccoGdpr />, document.getElementById('root')); 
                }
            }
        }
    }
    
    chiamaDeleteAccount(){
        ReactDOM.render(<DeleteAccount />, document.getElementById('ac-container') ); 
    }
    
    componentDidMount() {
 
        //this.setState({id_cliente: sessione.get('id_cliente') });
        this.impostaParametriHome();
        
        let request = new Request( config.get("anagrafica_cliente"),{
            method: 'POST', mode: 'cors', credentials: "include",
            body: JSON.stringify({ id_cliente: sessione.get('id_cliente') })
        });
        
        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            
            utils.gestisciMessaggio( result );
            
            if (result.success) {

                if('utente' in result.data ){sessione.set('datiutente' , result.data.utente );}
                
                /* Controllo eventuali Blocchi POPUP x Privacy/GDPR */
                this.controllaBlocchiPopupGDPR(result);
                
                
                let dati = [];
                let datigas = [];
                
                /* Info SITI e INDIRIZZI FATTURAZIONE */
                if ( result.data.siti !== null && result.data.siti.length > 0) {
                    sessione.set('siti' , result.data.siti );
                    
                    for (let i = 0; i < result.data.siti.length; i++) {
                        let r = result.data.siti[i];
                        
                        if( r.TIPO === 'E'){ dati.push(r); }
                        if( r.TIPO === 'G'){ datigas.push(r); }
                    }
                } else {
                    // svuota i siti, perchè se sto swhitchando con aggregato e arribo a un utenza senza siti, non me li svuota
                    sessione.set('siti' , null );
                    
                    // Nascondi i MENU delle pagine che richiedono un sito per mostrare dati
                    let el1 = document.getElementById('daticatastalimenubtn');
                    el1.parentElement.classList.add('nascosto');
                    
                    let el2 = document.getElementById('curvemenubtn');
                    el2.parentElement.classList.add('nascosto');
                    
                    let el3 = document.getElementById('registrimenubtn');
                    el3.parentElement.classList.add('nascosto'); 
                }
                
                /* Info UTENTE Loggato */
                if ( result.data.utente !== null ) {
                    let u = result.data.utente;
                    
                    this.setState({
                        utente: u
                        , gdpr_contratto : ( parseInt(u.FLG_GDPR_CONTRATTO,10)===1 ? 'SI' : ( parseInt(u.FLG_GDPR_CONTRATTO,10)===0 ? 'NO' : this.state.campo_vuoto ) )
                        , gdpr_commerciale : ( parseInt(u.FLG_GDPR_COMMERCIALE,10)===1 ? 'SI' : ( parseInt(u.FLG_GDPR_COMMERCIALE,10)===0 ? 'NO' : this.state.campo_vuoto ) )
                        , gdpr_profilazione : ( parseInt(u.FLG_GDPR_POFILAZIONE,10)===1 ? 'SI' : ( parseInt(u.FLG_GDPR_POFILAZIONE,10)===0 ? 'NO' : this.state.campo_vuoto ) )
                        , gdpr_infoprivacy : ( parseInt(u.FLG_GDPR_INFOPRIVACY,10)===1 ? 'SI' : ( parseInt(u.FLG_GDPR_INFOPRIVACY,10)===0 ? 'NO' : this.state.campo_vuoto ) )
                        , gdpr_terzeparti : ( parseInt(u.FLG_GDPR_TERZE_PARTI,10)===1 ? 'SI' : ( parseInt(u.FLG_GDPR_TERZE_PARTI,10)===0 ? 'NO' : this.state.campo_vuoto ) )
                    });
                }
                
                
                /* Info UTENTE Loggato */
                if ( result.data.commerciale !== null &&result.data.commerciale !== false ) {
                    if( 'errore' in result.data.commerciale){
                        this.setState({errore_commerciale: true , commerciale: result.data.commerciale});
                    } else {
                        this.setState({commerciale: result.data.commerciale});
                    }
                } else {
                    this.setState({vedi_commerciale:false});
                }

                if ( result.data.mancati_pagamenti !== null ) {
                    
                    if( 'ultimo_aggiornamento' in result.data.mancati_pagamenti && 'importo_partite' in result.data.mancati_pagamenti  )
                    {
                        let txt = '';
                        if( parseFloat(result.data.mancati_pagamenti.importo_partite) < 0){
                            txt = "<p><i className='ms-Icon ms-Icon--Warning' aria-hidden='true'></i><span className='testo'>Dall'ultima verifica del <span className='evidenzia'>"+result.data.mancati_pagamenti.ultimo_aggiornamento+"</span> risulta un credito a suo favore ";
                            txt = txt+ "per un totale di <span className='evidenzia'>"+result.data.mancati_pagamenti.importo_partite+"</span> &euro;."
                            
                            let infoChiarimenti = utils.getObjInfoSocieta( 'INFOCHIARIMENTI' , '' )
                            if( infoChiarimenti !== ''){ txt = txt + ' ' +infoChiarimenti; }
                            
                            txt = txt+ "</span></p>";
                        } else {
                            txt = "<p><i className='ms-Icon ms-Icon--Warning' aria-hidden='true'></i><span className='testo'>Dall'ultima verifica del <span className='evidenzia'>"+result.data.mancati_pagamenti.ultimo_aggiornamento+"</span> risultano pagamenti non effettuati ";
                            txt = txt+ "per un totale di <span className='evidenzia'>"+result.data.mancati_pagamenti.importo_partite+"</span> &euro;.</span></p>";
                        }
                        
                        let classe = 'warning';

                        if('partite' in result.data.mancati_pagamenti )
                        {
                            if( result.data.mancati_pagamenti.partite!==null && result.data.mancati_pagamenti.partite.length > 0 )
                            {
                                txt = txt+ "<p><span className='testo'>Dettaglio movimenti: </span></p><ul>";

                                for (let i =0 ; i< result.data.mancati_pagamenti.partite.length ; i++){
                                    txt = txt + '<li>'+result.data.mancati_pagamenti.partite[i] + '</li>';
                                }

                                txt = txt +'</ul>';
                            }
                            else { classe='nascosto'; }
                        }
                        else { classe='nascosto'; }
                        
                        if( result.data.mancati_pagamenti.importo_partite === 0) { classe='nascosto'; }
                        
                        this.setState( { vediwarningpagamenti:classe, warningpagamentitxt : txt } );
                    }
                    else {
                        this.setState( { vediwarningpagamenti:'nascosto', warningpagamentitxt : '' } );
                    }
                } else {
                    this.setState( { vediwarningpagamenti:'nascosto', warningpagamentitxt : '' } );
                }

                let vediEE = '';
                let vediGAS = '';

                if( dati.length === 0){ vediEE='nascosto';}
                if( datigas.length === 0){ vediGAS='nascosto';}

                this.setState({anagrafica: dati ,anagraficagas: datigas , visualizzaEE:vediEE , visualizzaGAS : vediGAS });

                utils.setBoxInfoCliente();

            } else {
                this.setState({errorMessage: result.message});
            }
        }.bind(this) );
        
        utils.setBoxInfoCliente();
    }

    render(){

        return (
            <div id="inner-container">    
                <Label className='ms-fontSize-xxl titolo-pagina'>Home<span id='boxdettagliocliente'></span></Label>
                
                <div id="dettaglioutente">
                    
                    <div className="msGrid">
                    <div className="ms-Grid-row">
                        
                        <div className='ms-Grid-col ms-sm4 gruppoanagrafica' >
                        
                            <Label className='ms-fontSize-l ms-fontWeight-semibold'>Anagrafica
                            
                            <div className={this.state.edit_anagrafica ? 'legenda c-pointer' : 'nascosto' }>
                                <span onClick={() => azioni.apriDialogBox( 'anagraficautente' ,  this.state.utente )}><i className="ms-Icon ms-Icon--Edit" aria-hidden="true"  ></i> Modifica </span>
                            </div>
                            </Label>
                            
                            <div className="msGrid">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Codice:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.utente.COD_CLIENTE}&nbsp;</div>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Rag. Sociale:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.utente.RAG_SOC}&nbsp;</div>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Codice Fiscale:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.utente.CODICE_FISCALE}&nbsp;</div>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Partita Iva:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.utente.PARTITA_IVA}&nbsp;</div>
                                </div>
                            </div>
                        </div>
                            
                        <div className='ms-Grid-col ms-sm4 gruppoanagrafica' >
                            <Label className='ms-fontSize-l ms-fontWeight-semibold'>Sede Legale
                            
                            <div className={this.state.edit_sedelegale ? 'legenda c-pointer' : 'nascosto' }>
                                <span onClick={() => azioni.apriDialogBox( 'sedelegaleutente' ,  this.state.utente )}><i className="ms-Icon ms-Icon--Edit" aria-hidden="true"  ></i> Modifica </span>
                            </div>
                            </Label>
                            
                            <div className="msGrid">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Indirizzo:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.utente.INDIRIZZO} {this.state.utente.NUM_CIVICO}&nbsp;</div>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Cap:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.utente.CAP}&nbsp;</div>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Comune (Prov.):</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.utente.COMUNE} ({this.state.utente.SIGLA_PROVINCIA})&nbsp;</div>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Provincia:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.utente.PROVINCIA}&nbsp;</div>
                                </div>
                            </div>
                        </div>
                        
                        <div className={this.state.vedi_commerciale ? 'ms-Grid-col ms-sm4 gruppoanagrafica' : 'nascosto' } >
                        
                            <Label className='ms-fontSize-l ms-fontWeight-semibold'>Commerciale</Label>
                            
                            <div className={this.state.errore_commerciale ? 'nascosto' : 'msGrid'} >
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Nome:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.commerciale.COGNOME}&nbsp; {this.state.commerciale.NOME}</div>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Email:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.commerciale.EMAIL}&nbsp;</div>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Telefono:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.commerciale.TEL}&nbsp;</div>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm4">Fax:</div>
                                    <div className="ms-Grid-col ms-sm8">{this.state.utente.FAX}&nbsp;</div>
                                </div>
                            </div>
                            
                            <div className={this.state.errore_commerciale ? 'msGrid' : 'nascosto'} >
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12">{this.state.commerciale.errore}&nbsp;</div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    </div>
                </div>
  
                
                <div id='privacy' className={this.state.vedi_privacy ? '' : 'nascosto' }>
                    <Label className='ms-fontSize-l ms-fontWeight-semibold'>Privacy
                    <div className={this.state.edit_privacy ? 'legenda c-pointer' : 'nascosto' }>
                        <span onClick={() => azioni.apriDialogBox( 'privacy' ,  this.state.utente )}><i className="ms-Icon ms-Icon--Edit" aria-hidden="true"  ></i> Modifica </span>
                    </div>
                    </Label>
                
                    <div className="msGrid">
                    <div className="ms-Grid-row">
                        <div className='ms-Grid-col ms-sm4 gruppoanagrafica' >
                            <div className='ms-Grid-col ms-sm9 descprivacy' >{this.state.gdpr_contratto_desc}</div>
                            <div className='ms-Grid-col ms-sm3 descprivacy' ><b>{this.state.gdpr_contratto}</b></div>
                        </div>
                        
                        <div className='ms-Grid-col ms-sm4 gruppoanagrafica' >
                            <div className='ms-Grid-col ms-sm9 descprivacy' >{this.state.gdpr_commerciale_desc}</div>
                            <div className='ms-Grid-col ms-sm3 descprivacy' ><b>{this.state.gdpr_commerciale}</b></div>
                        </div>
                        
                        <div className='ms-Grid-col ms-sm4 gruppoanagrafica' >
                            <div className='ms-Grid-col ms-sm9 descprivacy' >{this.state.gdpr_profilazione_desc}</div>
                            <div className='ms-Grid-col ms-sm3 descprivacy' ><b>{this.state.gdpr_profilazione}</b></div>
                        </div>
                    </div>
                    <div className={this.state.vedi_terze_parti ? 'ms-Grid-row' : 'ms-Grid-row nascosto' }>
                        <div className='ms-Grid-col ms-sm4 gruppoanagrafica' >
                            <div className='ms-Grid-col ms-sm9 descprivacy' >{this.state.gdpr_terzeparti_desc}</div>
                            <div className='ms-Grid-col ms-sm3 descprivacy' ><b>{this.state.gdpr_terzeparti}</b></div>
                        </div>
                    </div>
                    </div>
                </div>


                <div id="warning" className={this.state.vediwarningpagamenti}>
                    {renderHTML(this.state.warningpagamentitxt)}
                </div>
                
                
                <div id="elencoanagrafiche" className={"DetailListContainer " + this.state.visualizzaEE }>
                <Label className='ms-fontSize-l ms-fontWeight-semibold'>Siti Energia Elettrica</Label>
                <DetailsList
                    items={this.state.anagrafica}
                    columns={ azioni.restituisciColonneSiti('ee') }
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={ SelectionMode.none }
                />
                </div>
                
                <div id="elencoanagrafichegas" className={"DetailListContainer " + this.state.visualizzaGAS }>
                <Label className='ms-fontSize-l ms-fontWeight-semibold'>Siti Gas</Label>
                <DetailsList
                    items={this.state.anagraficagas}
                    columns={ azioni.restituisciColonneSiti('gas') }
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={ SelectionMode.none }
                />
                </div>
                
                
                <div id="elencoanagrafichefatture" className={"DetailListContainer " + this.state.visualizzaEE }>
                <Label className="ms-fontSize-l ms-fontWeight-semibold">Indirizzi Fatturazione Energia Elettrica</Label>
                <DetailsList
                    items={this.state.anagrafica}
                    columns={ azioni.restituisciColonneAnagraficaSpedizioni('ee') }
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                  />
                </div>
                  
                <div id="elencoanagrafichefatturegas" className={"DetailListContainer "+ this.state.visualizzaGAS}>
                <Label className="ms-fontSize-l ms-fontWeight-semibold">Indirizzi Fatturazione Gas</Label>
                <DetailsList
                    items={this.state.anagraficagas}
                    columns={ azioni.restituisciColonneAnagraficaSpedizioni('gas') }
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                  />
                </div>

                <div className='legenda'>
                    <span><i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i> Modifica </span>
                    <span><i className="ms-Icon ms-Icon--MailReminder" aria-hidden="true"></i> Segnalazioni </span>
                    <span><i className="ms-Icon ms-Icon--NumberedList" aria-hidden="true"></i> Autoletture </span>
                </div>
                
                <div className='bottonElimina'>
                    <PrimaryButton text="Elimina Account Area Clienti" onClick={() => azioni.apriDialogBox( 'eliminaaccount' ,  this.state.utente )} className={this.state.mostraEliminaAccount}/>
                    <PrimaryButton id="eliminaBtnPassword" text="Elimina il tuo account" onClick={() => this.chiamaDeleteAccount()} className={this.state.mostraCancellaPassword}/>
                </div>
            
                <div id="boxdialogo"></div>
            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/AcComponents/Home.js